import type { InfoSocietePappersType } from '../service/info-societe-pappers.definition';

export const infoSocietePappersUrl = '/info-societe-pappers';

export type GetInfoSocietePappersResponse = InfoSocietePappersType;
